import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option } = Select;

const esObjectId = (v) => /^[a-f\d]{24}$/i.test(String(v || ""));

class SelectGruposEscuelaItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: true,
      texto: "",
    };
    this.buscarGrupos = debounce(this.buscarGrupos.bind(this), 300);
  }

  componentDidMount() {
    this.buscarGrupos("", true);
    if (this.props.value) this.asegurarValor(this.props.value);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.escuelaId !== this.props.escuelaId) {
      this.setState({ opciones: [], primerCarga: true, texto: "" }, () => {
        this.buscarGrupos("", true);
        if (this.props.value) this.asegurarValor(this.props.value);
      });
      return;
    }
    if (prevProps.value !== this.props.value && this.props.value) {
      this.asegurarValor(this.props.value);
    }
  }

  async asegurarValor(value) {
    const val = value?.toString();
    if (!val || !esObjectId(val)) return;
    if (this.state.opciones.some((o) => o._id?.toString() === val)) return;
    try {
      const res = await axios.post(
        "gruposEscuela/selectGruposEscuelaItem",
        {
          query: val,
          skip: 0,
          empresaId: this.props.empresaId,
          escuelaId: this.props.escuelaId,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2 && res.data.grupos?.length) {
        this.setState((prev) => {
          const existentes = new Set(
            prev.opciones.map((o) => o._id?.toString())
          );
          const nuevos = res.data.grupos.filter(
            (g) => !existentes.has(g._id?.toString())
          );
          return { opciones: [...nuevos, ...prev.opciones] };
        });
      }
    } catch (err) {
      console.error(err);
    }
  }

  async buscarGrupos(texto, inicial, append = false) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "gruposEscuela/selectGruposEscuelaItem",
        {

          query: append ? this.state.texto || "" : texto || "",
          skip: append ? this.state.opciones.length : 0,
          empresaId: this.props.empresaId,
          escuelaId: this.props.escuelaId,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        this.setState(
          (prev) => ({
            opciones: append
              ? [...prev.opciones, ...res.data.grupos]
              : res.data.grupos,
            primerCarga: false,
            texto: append ? prev.texto : texto,
          }),
          () => {
            // Tras un reset, reasegurar el value seleccionado.
            if (!append && this.props.value)
              this.asegurarValor(this.props.value);
          }
        );
      } else {
        this.setState({ opciones: [] });
      }
    } catch (err) {
      console.error(err);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  render() {
    const { noBuscar, disabled, sinBorde, width, style, placeholder, ...rest } =
      this.props;

    const opcionesUnicas = [];
    const vistos = new Set();
    for (const g of this.state.opciones) {
      const id = g._id?.toString();
      if (vistos.has(id)) continue;
      vistos.add(id);
      opcionesUnicas.push(g);
    }

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={false}
        disabled={disabled}
        showSearch={!noBuscar}
        filterOption={false}
        onSearch={this.buscarGrupos}
        loading={this.state.cargando}
        notFoundContent={
          this.state.cargando ? "Buscando..." : "No se encontraron grupos"
        }
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>{menu}</Spin>
        )}
        {...rest}
        onChange={(value) => {
          const grupo = this.state.opciones.find((e) => e._id === value);
          if (this.props.onChange) this.props.onChange(value, grupo);
        }}
        placeholder={placeholder}
        style={{ width: width || "100%", ...style }}
        bordered={!sinBorde}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            this.buscarGrupos(this.state.texto || "", false, true);
          }
        }}
      >
        {opcionesUnicas.map((g) => (
          <Option key={g._id} value={g._id}>
            {g.stringBuscar || g.nombre}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectGruposEscuelaItem;
